import { BaseApiClient } from './baseApiClient';
import type { ApiResponse } from './baseApiClient';
import type { HilPresentationRequestEnvelope } from '@bizfirst/hil-types';
import type { InboxItemRecord, HilEventLogRecord } from './hilInboxTypes';
import { mapInboxItemToV13Envelope } from './hilInboxEnvelopeMapper';

/** Fetches pending HIL inbox items and event logs from the backend. */
export class HilInboxApiClient extends BaseApiClient {
  getPendingItems(actorID: string): Promise<ApiResponse<InboxItemRecord[]>> {
    return this.postQuery<InboxItemRecord[]>('/api/v1/ai/inbox-items/pending', { actorID });
  }

  getEventLogBySession(engageSessionID: number): Promise<ApiResponse<HilEventLogRecord[]>> {
    return this.postQuery<HilEventLogRecord[]>(
      '/api/v1/process/hil-event-logs/by-engage-session',
      { engageSessionID }
    );
  }

  /** Delegates to the pure mapper; passes this client's baseUrl for the callback URL. */
  mapToV13Envelope(
    item: InboxItemRecord,
    log: HilEventLogRecord | null
  ): HilPresentationRequestEnvelope {
    return mapInboxItemToV13Envelope(item, log, this.baseUrl);
  }
}

export const hilInboxApiClient = new HilInboxApiClient();
